import * as React from 'react'
import { FC } from 'react'
import { useSelector } from 'react-redux'

import { SalesFunnelDetails } from './SalesFunnelDetails/SalesFunnelDetails'
import { SalesFunnelSummary } from './SalesFunnelSummary/SalesFunnelSummary'
import {
  selectAllSalesFunnelCards,
  selectSalesFunnelSummary,
} from '@user/store/salesFunnelSummary/slice'
import { useGetSalesFunnelSummaryOnMount } from '@user/store/salesFunnelSummary/hooks/useGetSalesFunnelSummaryOnMount'

import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'

interface Props {
  onClose: () => void
}

const SalesFunnelSummaryLoadingIndicator: FC = () => {
  return (
    <>
      <Skeleton variant="rectangular" height="350px" />
      <Box p={2}>
        <Box mb={1}>
          <Skeleton variant="rectangular" height="75px" />
        </Box>
        <Skeleton variant="rectangular" height="225px" />
      </Box>
    </>
  )
}

export const SalesFunnelDialogContent: FC<Props> = (props) => {
  const { onClose } = props

  const status = useGetSalesFunnelSummaryOnMount()
  const summaryCard = useSelector(selectSalesFunnelSummary)
  const funnelCards = useSelector(selectAllSalesFunnelCards)

  return (
    <>
      {status == 'pending' && <SalesFunnelSummaryLoadingIndicator />}
      {status == 'success' && (
        <>
          {!!summaryCard && (
            <SalesFunnelSummary
              summaryCard={summaryCard}
              handleClose={onClose}
            />
          )}
          {!!funnelCards && (
            <SalesFunnelDetails
              funnelCards={funnelCards}
              handleClose={onClose}
            />
          )}
        </>
      )}
      {status == 'fail' && (
        <Alert severity="error"> Failed to load Sales Funnel details.</Alert>
      )}
    </>
  )
}

SalesFunnelDialogContent.displayName = 'SalesFunnelDialogContent'
